import analysisImg from "../../../../images/contents/map/tropicalstorm/analysis.png";
import customImg from "../../../../images/contents/map/tropicalstorm/custom.png";
import disspatedImg from "../../../../images/contents/map/tropicalstorm/DISSIPATED.png";
import tDImg from "../../../../images/contents/map/tropicalstorm/TD.png";
import tSImg from "../../../../images/contents/map/tropicalstorm/TS.png";
import tSSouthImg from "../../../../images/contents/map/tropicalstorm/TS_south.png";
import tYImg from "../../../../images/contents/map/tropicalstorm/TY.png";
import tYSouthImg from "../../../../images/contents/map/tropicalstorm/TY_south.png";
import sTSImg from "../../../../images/contents/map/tropicalstorm/STS.png";
import sTSSouthImg from "../../../../images/contents/map/tropicalstorm/STS_south.png";
import xTImg from "../../../../images/contents/map/tropicalstorm/XT.png";

export const configCycloneDhWniIndex = {
  "Controller": {
    "Name": "IndexedJSON"
  },
  "Source": {
    "index": {
      "Type": "JSON",
      "url": "%wrap_url%/WX_WNI_TropicalStorm/index.json",
      "data_load_term_days": 1,
      "update_interval": 60,
      "cache_busting": true
    },
    "element": {
      "Type": "JSON",
      "url": "%wrap_url%/WX_WNI_TropicalStorm/TropicalStorm/%id%.json",
      "cache_busting": true,
      "download_max": 32
    },
    "data": {
      "Type": "Derived",
      "retain": true
    }
  }
};

export const configCycloneWniLayer = {
  "Name": "TropicalStorm",
  "Renderer": "TropicalStormExt",
  "Attributes": {
    "track_history_line_color": "#802020",
    "track_history_line_width": 2,
    "_forecst_track_line_color": "#2020ee",
    "forecst_track_line_color": "#0000ff",
    "forecst_track_line_width": 2,
    "wind_line_color_gale": "rgba(255,201,102,1.0)",
    "wind_line_color_storm": "rgba(255,50,50,1.0)",
    "wind_line_width": 1,
    "wind_fill_color_gale": "rgba(255,201,102,0.3)",
    "wind_fill_color_storm": "rgba(255,50,50,0.3)",
    "wind_highlight_line_width": 5,
    "label_text_color": "#202020",
    "label_edge_color": "#ffffff",
    "label_offset_x": 10,
    "label_offset_y": 10,
    "label_font_size": 14,
    "date_format": "%day%/%0hour%Z",
    "date_format_bylocale": "D/HH z[Z]",
    "icon": {
      "HUR": tYImg,
      "CYC": tYImg,
      "TY": tYImg,
      "STS": tSImg,
      "TS": tSImg,
      "TD": tDImg,
      "XT": xTImg
    },
    "icon_south": {
      "HUR": tYSouthImg,
      "CYC": tYSouthImg,
      "TY": tYSouthImg,
      "STS": tSSouthImg,
      "TS": tSSouthImg
    },
    "icon_width": 16,
    "icon_height": 23,
    "icon_offset_x": -8,
    "icon_offset_y": -12,
    "show_forecast_track": true,
    "show_track_history": true,
    "show_forecast_wind_radii": true,
    "show_analysis_wind_radii": true,
    "show_datetime": true,
    "show_number": true
  }
};

export const configCycloneDhJMAIndex = {
  "Controller": {
      "Name": "IndexedJSON",
      "_Name": "EXPO_PointSetDB"
  },
  "Source": {
      "index": {
          "Type": "JSON",
          "url": "%wrap_url%/WX_JMA_Typhoon/index.json",
          "_url": "./pri/conf/dummy/WX_JMA_Typhoon/index.json",
          "data_load_term_days": 14,
          "update_interval": 300,
          "cache_busting": true
      },
      "element": {
          "Type": "JSON",
          "url": "%wrap_url%/WX_JMA_Typhoon/TropicalStorm/%id%.json",
          "cache_busting": true,
          "download_max": 32
      },
      "data": {
          "Type": "Derived",
          "retain": true
      }
  }
};

export const configCycloneJMALayer = {
  "Name": "JMA_Typhoon",
  "Renderer": "Typhoon",
  "Attributes": {
    "icon_width": 16,
    "icon_height": 23,
    "icon_offset_x": -8,
    "icon_offset_y": -12,
    "icon": {
      "track": {
        "icon": "",
        "class_icon": {
          "STS": sTSImg,
          "TS": tSImg,
          "TD": tDImg,
          "TY": tYImg,
          "LOW": xTImg
        }
      },
      "analysis": {
        "icon": analysisImg,
        "class_icon": {
          "STS": "",
          "TS": "",
          "TD": "",
          "TY": "",
          "LOW": ""
        }
      },
      "estimate": {
        "icon": analysisImg,
        "class_icon": {
          "STS": sTSImg,
          "TS": tSImg,
          "TD": tDImg,
          "TY": tYImg,
          "LOW": xTImg
        }
      },
      "forecast": {
        "icon": "",
        "class_icon": {
          "STS": sTSImg,
          "TS": tSImg,
          "TD": tDImg,
          "TY": tYImg,
          "LOW": xTImg
        }
      },
      "custom_icon": customImg
    },
    "track_history_line_color": "#202080",
    "track_history_line_width": 2,
    "forecst_track_line_color": "#ffffff",
    "forecst_track_line_width": 2,
    "_forecst_track_line_dash": [4],
    "forecst_circle_line_color": "#ffffff",
    "forecst_circle_line_width": 2,
    "forecst_circle_line_dash": [4],
    "forecst_area_line_color": "#ffffff",
    "forecst_area_line_width": 2,
    "forecst_area_line_dash": [],
    "wind_line_color_gale": "rgba(255,255,150,1.0)",
    "wind_line_color_storm": "rgba(255,50,50,1.0)",
    "wind_line_width": 2,
    "wind_fill_color_gale": "rgba(255,255,100,0.3)",
    "wind_fill_color_storm": "rgba(255,50,50,0.3)",
    "wind_highlight_line_width": 5,
    "label_text_color": "#202020",
    "label_edge_color": "#ffffff",
    "label_offset_x": 10,
    "label_offset_y": 10,
    "label_font_size": 12,
    "__date_format": "%0local_month%月%local_day%日%local_hour%時",
    "_date_format": "%local_year%年%0local_month%月%local_day%日%local_hour%時",
    "date_format": "%day%/%0hour%Z a",
    "date_format_bylocale": "D/HH z[Z]",
    "number_label_text_color": "black",
    "number_label_edge_color": "white",
    "number_label_offset_x": 5,
    "number_label_offset_y": -14,
    "number_label_font_size": 20,
    "number_label": "台風%d%号",
    "_number_label": "No.%d%",
    "show_forecast_circle": true,
    "show_forecast_track": true,
    "show_track": true,
    "show_estimate": true,
    "show_td_low": true,
    "show_datetime": true,
    "show_number": true,
    "_contact_angle_threshold": 20,
    "show_track_history": true,
    "show_analysis_wind_radii": true,
    "show_forecast_wind_radii": true
  },
  "language": {
    "en": {
      "number_label": "No.%d%",
      "date_format": "%day%/%0hour%Z b",
    },
    "ja": {
      "number_label": "台風%d%号",
      "date_format": "%local_day%/%local_hour% c",
    }
  }
};

export const configCycloneDhJTWCIndex = {
  "Controller": {
      "Name": "IndexedJSON"
  },
  "Source": {
      "index": {
          "Type": "JSON",
          "url": "%wrap_url%/WX_JTWC_Typhoon/index.json",
          "_url": "./pri/conf/dummy/WX_JTWC_Typhoon/index.json",
          "data_load_term_days": 14,
          "update_interval": 60,
          "cache_busting": true
      },
      "element": {
          "Type": "JSON",
          "url": "%wrap_url%/WX_JTWC_Typhoon/TropicalStorm/%id%.json",
          "cache_busting": true,
          "download_max": 32
      },
      "data": {
          "Type": "Derived",
          "retain": true
      }
  }
};

export const configCycloneJTWCLayer = {
  "Name": "JTWC_Typhoone",
  "Renderer": "TropicalStormExt",
  "Attributes": {
    "track_history_line_color": "#802020",
    "track_history_line_width": 2,
    "forecst_track_line_color": "#ed9a37",
    "forecst_track_line_width": 2,
    "wind_line_color_gale": "rgba(255,255,150,1.0)",
    "wind_line_color_storm": "rgba(255,50,50,1.0)",
    "wind_line_color_hurricane": "rgba(200,0,0,1.0)",
    "wind_line_width": 1,
    "wind_fill_color_gale": "rgba(255,255,100,0.3)",
    "wind_fill_color_storm": "rgba(255,50,50,0.3)",
    "wind_fill_color_hurricane": "rgba(200,0,0,0.3)",
    "wind_highlight_line_width": 5,
    "label_text_color": "#202020",
    "label_edge_color": "#ffffff",
    "label_offset_x": 10,
    "label_offset_y": 10,
    "label_font_size": 12,
    "_date_format": "%local_year%年%0local_month%月%local_day%日%local_hour%時",
    "date_format": "%day%/%0hour%Z",
    "date_format_bylocale": "D/HH z[Z]",
    "icon": {
      "DISSIPATED": disspatedImg,
      "TROPICAL DEPRESSION": tDImg,
      "TYPHOON": tYImg,
      "SUPER TYPHOON": tYImg,
      "TROPICAL STORM": tSImg,
      "TD": tDImg,
      "TY": sTSImg,
      "STY": tYImg,
      "TS": tSImg
    },
    "icon_south": {
      "STS": sTSSouthImg,
      "TS": tSSouthImg
    },
    "custom_icon": customImg,
    "icon_width": 16,
    "icon_height": 23,
    "icon_offset_x": -8,
    "icon_offset_y": -12,
    "show_forecast_track": true,
    "show_track_history": true,
    "show_forecast_wind_radii": true,
    "show_analysis_wind_radii": true,
    "show_datetime": true,
    "show_number": true
  }
}
